export class KeyframeNodeList {
    get count() {
        return this._nodes.length;
    }
    set count(value) {
        this._nodes.length = value;
    }
    constructor() {
        this._nodes = [];
    }
    getNodeByIndex(index) {
        return this._nodes[index];
    }
    setNodeByIndex(index, node) {
        this._nodes[index] = node;
    }
}
